import {GuidePostSerializer} from "@oldDashboard/legacyModels/serializers/guidePostSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";
export class CommandTotalGpSummary {
    async run(launchSelected: String, startDate: String, endDate: String) {  
        const path = `get-chart-data/client:total-gp-summary/?launch_id=${launchSelected}&start_date=${startDate}&end_date=${endDate}&sort=`
        try {
            const response = await legacyReportingGet(path);
            return response
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: any) {
        const serializer = new GuidePostSerializer();
        return serializer.deserializeList(data);
    }
}

